import React, { useState } from "react";
import PropTypes from "prop-types";

import { VideoModalWrapper } from "./styles";
import { Modal } from "../../../Elements";
import ReactPlayer from "react-player/lazy";

const VideoModal = ({ show, onClose, url }) => {
	return (
		<VideoModalWrapper className="modalContainer">
			<Modal show={show} disableBackdropClick={true} onClose={onClose}>
				<div className="modalBody">
					<ReactPlayer className="videoContainer" url={url} controls playing />
				</div>
			</Modal>
		</VideoModalWrapper>
	);
};

VideoModal.defaultProps = {
	show: false,
	onClose: () => {},
	url: "",
};

VideoModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	url: PropTypes.string,
};

export default VideoModal;
